import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant4PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 876 867",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.3728 636.539C116.791 693.188 163.298 756.85 233.796 784.862C265.158 797.326 300.809 801.079 332.886 790.625C377.964 775.882 408.477 734.602 414.33 688.407C420.897 636.673 383.503 589.764 348.657 555.051C313.497 520.07 273.244 488.619 248.762 445.462C208.286 374.16 240.989 277.303 317.428 246.388C366.08 226.731 423.399 230.796 466.108 262.203C511.186 295.397 520.3 355.262 528.788 406.996C536.874 456.318 548.267 509.616 586.554 541.693C630.514 578.55 700.7 573.502 745.241 537.36C789.783 501.217 809.663 440.369 805.24 383.184C801.354 332.746 780.445 285.747 753.149 243.752C730.319 208.637 667.266 93.7759 630.989 70.5",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant4PathwayIllustration as default };
